import React, { useState, useEffect } from 'react';
import NodeTreeButton from './NodeTreeButton';
import {TextField, Box} from '@mui/material';
 
const NodeUdidSelectInput = props => {
    const [value, setValue] = useState('');
    const [showValue, setShowValue] = useState('');
    const [sketchJson, setSketchJson] = React.useState({});
    const [targetNode, setTargetNode] = React.useState(null);

    const findNodeRecur = (sketch_json, node_udid) => {
        if(sketch_json.do_objectID == node_udid){
          return sketch_json
        }
        for(let i=0;sketch_json.layers && i<sketch_json.layers.length;i++){
          let r = findNodeRecur(sketch_json.layers[i], node_udid)
          if(r)
            return r
        }
        return null
    }

    const findNodeRecurByName = (sketch_json, node_name) => {
        if(sketch_json.name == node_name){
          return sketch_json
        }
        for(let i=0;sketch_json.layers && i<sketch_json.layers.length;i++){
          let r = findNodeRecurByName(sketch_json.layers[i], node_name)
          if(r)
            return r
        }
        return null
    }

    useEffect(() => {
        if(props.value){
            setValue(props.value)
            let found = findNodeRecur(sketchJson, props.value)
            if(found)
                setShowValue(found.name)
        } else {
            setValue('')
        }

        if(props.sketchJson && props.targetNode){
            let found = findNodeRecur(props.sketchJson, props.targetNode)
            setSketchJson(found)
            setTargetNode(props.targetNode)
        } else {
            setSketchJson(props.sketchJson)
            setTargetNode(props.targetNode)
        }

    }, [props.value, props.sketchJson, props.targetNode])

    const handleShowValueChange = (newValue) => {
        
    }

    const handleNodeSelected = (udid, name) => {
        setValue(udid)
        setShowValue(name)
        if(props.onChange)
            props.onChange(udid)
    }
    return (
        <Box>
            <TextField label={props.label} value={showValue} onChange={(e)=>handleShowValueChange(e.target.value)} />
            <NodeTreeButton selectableJsonDepth={props.selectableJsonDepth} onSelected={handleNodeSelected} json={sketchJson} />
        </Box>
    );
};

export default NodeUdidSelectInput;
